
// import React, { useEffect, useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { motion } from "framer-motion";
// import axios from "axios";
// import { useTeacherAuth } from "../auth/TeacherAuthContext";
// import {
//   Box,
//   Typography,
//   Grid,
//   Card,
//   CardContent,
//   Button,
//   CircularProgress,
//   IconButton,
//   Divider,
//   Container,
//   AppBar,
//   Toolbar,
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Avatar,
//   Badge,
//   useMediaQuery,
//   useTheme,
//   Paper,
//   Chip,
// } from "@mui/material";
// import {
//   School as SchoolIcon,
//   People as PeopleIcon,
//   Person as PersonIcon,
//   Event as EventIcon,
//   Schedule as ScheduleIcon,
//   Edit as EditIcon,
//   NewReleases as NewsIcon,
//   Bolt as BoltIcon,
//   Public as PublicIcon,
//   Workspaces as WorkspacesIcon,
//   Assessment as AssessmentIcon,
//   Forum as ForumIcon,
//   Menu as MenuIcon,
//   Home as HomeIcon,
//   Star as StarIcon,
//   Notifications as NotificationsIcon,
//   AccountCircle as AccountCircleIcon,
//   Class as ClassIcon,
//   Book as BookIcon,
//   Groups as GroupsIcon,
//   Assignment as AssignmentIcon,
//   EmojiEvents as EmojiEventsIcon,
//   Dashboard as DashboardIcon,
//   BarChart as BarChartIcon,
//   Settings as SettingsIcon,
//   ExitToApp as ExitToAppIcon,
//   VideoLibrary as VideoLibraryIcon,
//   CloudUpload as CloudUploadIcon,
//   PlayCircleFilled as PlayCircleFilledIcon,
//   EventAvailable as EventAvailableIcon,
//   OndemandVideo as OndemandVideoIcon,
//   Note as NoteIcon,
//   AssignmentTurnedIn as AssignmentTurnedInIcon,
//   TrendingUp as TrendingUpIcon,
// } from "@mui/icons-material";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const TeacherDashboard = () => {
//   const navigate = useNavigate();
//   const { pathname } = useLocation();
//   const { teacherData, logout } = useTeacherAuth();
//   const schoolId = teacherData?.schoolId;
//   const { teacherId, teacherName, gender, schoolName } = teacherData || {};

//   const [learners, setLearners] = useState([]);
//   const [stats, setStats] = useState({
//     totalStudents: 0,
//     totalAssignments: 0,
//     totalVideos: 0,
//     attendance: "95%",
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [statsLoading, setStatsLoading] = useState(true);
//   const [nationalEvents, setNationalEvents] = useState([]);
//   const [scholarships, setScholarships] = useState([]);
//   const [scholarshipsLoading, setScholarshipsLoading] = useState(true);
//   const [scheduledExams, setScheduledExams] = useState([]);
//   const [examsLoading, setExamsLoading] = useState(true);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [notifications, setNotifications] = useState([]);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   // Determine the title based on gender
//   const title = gender === "M" ? `Mr. ${teacherName}` : `Ms. ${teacherName}`;

//   useEffect(() => {
//     AOS.init({
//       duration: 800,
//       easing: "ease-in-out",
//       once: true,
//     });
//   }, []);

//   const getTimeBasedGreeting = () => {
//     const hour = new Date().getHours();
//     return hour < 12
//       ? "Good Morning"
//       : hour < 17
//       ? "Good Afternoon"
//       : "Good Evening";
//   };

//   const calculateTimeRemaining = (endDate) => {
//     if (!endDate) return "N/A";
//     const now = new Date();
//     const end = new Date(endDate);
//     const diff = end - now;

//     if (diff <= 0) return "Expired";

//     const days = Math.floor(diff / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((diff % (1000 * 60)) / 1000);

//     return `${days}d ${hours}h ${minutes}m ${seconds}s`;
//   };

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       if (!teacherId || !schoolId) {
//         throw new Error("Missing teacher or school information");
//       }

//       const [
//         learnersRes,
//         assignmentsRes,
//         videosRes,
//         nationalEventsRes,
//         scholarshipsRes,
//         scheduledExamsRes,
//       ] = await Promise.all([
//         axios.get("https://kidsm.vercel.app/api/schools/learners", {
//           params: { schoolId },
//         }),
//         axios.get(
//           `https://kidsm.vercel.app/api/schools/${schoolId}/teachers/${teacherId}/assignments/count`,
//           { params: { schoolId } }
//         ),
//         axios.get(
//           `https://kidsm.vercel.app/api/schools/${schoolId}/teachers/${teacherId}/videos/stats`,
//           { params: { schoolId } }
//         ),
//         axios.get(
//           "https://kidsm.vercel.app/api/schools/latest-amplified-events"
//         ),
//         axios.get("https://kidsm.vercel.app/api/schools/latest-scholarships"),
//         axios.get("https://kidsm.vercel.app/api/schools/scheduled-exams", {
//           params: { schoolId },
//         }),
//       ]);

//       setLearners(learnersRes.data || []);
//       setNationalEvents(nationalEventsRes.data || []);
//       setScholarships(scholarshipsRes.data || []);
//       setScheduledExams(
//         (scheduledExamsRes.data.exams || []).map((exam) => ({
//           ...exam,
//           timeRemaining: calculateTimeRemaining(exam.endDate),
//         }))
//       );

//       setStats({
//         totalStudents: learnersRes.data?.length || 0,
//         totalAssignments: assignmentsRes.data?.count || 0,
//         totalVideos: videosRes.data?.totalVideos || 0,
//         attendance: "95%",
//       });
//     } catch (error) {
//       console.error("Error fetching dashboard data:", error);
//       setError(error.message || "Failed to load dashboard data");
//       // Set empty states for all data
//       setLearners([]);
//       setNationalEvents([]);
//       setScholarships([]);
//       setScheduledExams([]);
//       setStats({
//         totalStudents: 0,
//         totalAssignments: 0,
//         totalVideos: 0,
//         attendance: "0%",
//       });
//     } finally {
//       setLoading(false);
//       setStatsLoading(false);
//       setScholarshipsLoading(false);
//       setExamsLoading(false);
//     }
//   };

//   useEffect(() => {
//     console.log("School ID:", schoolId);
//     if (teacherId && schoolId) {
//       fetchData();
//       const interval = setInterval(() => {
//         setScheduledExams((prevExams) =>
//           prevExams.map((exam) => ({
//             ...exam,
//             timeRemaining: calculateTimeRemaining(exam.endDate),
//           }))
//         );
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [teacherId, schoolId]);

//   const groupLearnersByClass = (learners) => {
//     return learners.reduce((acc, learner) => {
//       const { class: className } = learner;
//       if (!acc[className]) acc[className] = [];
//       acc[className].push(learner);
//       return acc;
//     }, {});
//   };

//   const learnersByClass = groupLearnersByClass(learners);

//   const cardVariants = {
//     hidden: { opacity: 0, scale: 0.9, y: 30 },
//     visible: {
//       opacity: 1,
//       scale: 1,
//       y: 0,
//       transition: { duration: 0.5, ease: "easeOut" },
//     },
//     hover: { scale: 1.05, transition: { duration: 0.2 } },
//   };

//   const statVariants = {
//     pulse: {
//       scale: [1, 1.05, 1],
//       transition: { repeat: Infinity, duration: 2 },
//     },
//   };

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/teacher/login");
//   };

//   const drawer = (
//     <Box sx={{ width: 250, bgcolor: "background.paper", height: "100%" }}>
//       <Box
//         sx={{
//           p: 2,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           bgcolor: "#6200ee",
//           color: "white",
//         }}
//       >
//         <SchoolIcon sx={{ mr: 1, fontSize: 32 }} />
//         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//           {title}
//         </Typography>
//       </Box>
//       <Divider />
//       <List>
//         {[
//           { text: "Dashboard", icon: <DashboardIcon />, path: "/teacher" },
//           {
//             text: "My Students",
//             icon: <PersonIcon />,
//             path: "/teacher/students",
//             state: { schoolId },
//           },
//           {
//             text: "Update Results",
//             icon: <EditIcon />,
//             path: "/teacher/update-results",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Video Library",
//             icon: <VideoLibraryIcon />,
//             path: "/teacher/videos",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Upload Notes",
//             icon: <NoteIcon />,
//             path: "/teacher/upload-notes",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Assignments",
//             icon: <AssignmentIcon />,
//             path: "/teacher/assignments",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Create Assignment",
//             icon: <AssignmentTurnedInIcon />,
//             path: "/teacher/create-assignment",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Upload Video",
//             icon: <CloudUploadIcon />,
//             path: "/teacher/upload-video",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Class Performance",
//             icon: <TrendingUpIcon />,
//             path: "/teacher/performance",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "National Events",
//             icon: <PublicIcon />,
//             path: "/teacher/events",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Scholarships",
//             icon: <EmojiEventsIcon />,
//             path: "/teacher/scholarships",
//             state: { schoolId, teacherId },
//           },
//           {
//             text: "Settings",
//             icon: <SettingsIcon />,
//             path: "/teacher/profile",
//             state: { schoolId, teacherId },
//           },
//           { text: "Logout", icon: <ExitToAppIcon />, action: handleLogout },
//         ].map((item, index) => (
//           <ListItem
//             button
//             key={index}
//             onClick={() =>
//               item.action
//                 ? item.action()
//                 : navigate(item.path, { state: item.state })
//             }
//             sx={{
//               "&:hover": { bgcolor: "#f5f5f5" },
//               borderRadius: 1,
//               mx: 1,
//               my: 0.5,
//             }}
//           >
//             <ListItemIcon sx={{ color: "#6200ee" }}>{item.icon}</ListItemIcon>
//             <ListItemText
//               primary={item.text}
//               primaryTypographyProps={{ fontWeight: "medium" }}
//             />
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           height: "100vh",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         }}
//       >
//         <motion.div
//           animate={{ rotate: 360 }}
//           transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
//         >
//           <CircularProgress size={80} thickness={4} color="primary" />
//         </motion.div>
//         <Typography
//           variant="h6"
//           sx={{
//             mt: 3,
//             color: "#2c3e50",
//             fontWeight: "bold",
//             background: "linear-gradient(to right, #6200ee, #03dac6)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//           }}
//         >
//           Loading your teacher dashboard...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "center",
//           height: "100vh",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//           p: 3,
//           textAlign: "center",
//         }}
//       >
//         <Typography
//           variant="h5"
//           color="error"
//           sx={{ mb: 2, fontWeight: "bold" }}
//         >
//           Error Loading Dashboard
//         </Typography>
//         <Typography variant="body1" sx={{ mb: 3 }}>
//           {error}
//         </Typography>
//         <Button
//           variant="contained"
//           color="primary"
//           onClick={fetchData}
//           sx={{ mb: 2 }}
//         >
//           Retry
//         </Button>
//         <Button variant="outlined" color="primary" onClick={handleLogout}>
//           Logout
//         </Button>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f8f9fa" }}>
//       <AppBar
//         position="fixed"
//         sx={{
//           zIndex: theme.zIndex.drawer + 1,
//           bgcolor: "white",
//           color: "#2c3e50",
//           boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         }}
//       >
//         <Toolbar>
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { md: "none" }, color: "#6200ee" }}
//           >
//             <MenuIcon />
//           </IconButton>
//           <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
//             <SchoolIcon sx={{ color: "#6200ee", mr: 1, fontSize: 32 }} />
//             <Typography
//               variant="h6"
//               noWrap
//               component="div"
//               sx={{
//                 fontWeight: "bold",
//                 background: "linear-gradient(to right, #6200ee, #03dac6)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               {title} - {schoolName}
//             </Typography>
//           </Box>

//           <Box
//             sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}
//           >
//             <IconButton size="large" color="inherit" sx={{ color: "#6200ee" }}>
//               <Badge badgeContent={notifications.length} color="error">
//                 <NotificationsIcon />
//               </Badge>
//             </IconButton>
//             <IconButton
//               size="large"
//               edge="end"
//               aria-label="account of current user"
//               aria-haspopup="true"
//               color="inherit"
//               sx={{ color: "#6200ee" }}
//               onClick={() =>
//                 navigate("/teacher/profile", { state: { schoolId, teacherId } })
//               }
//             >
//               <AccountCircleIcon />
//             </IconButton>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       <Box
//         component="nav"
//         sx={{ width: { md: 250 }, flexShrink: { md: 0 } }}
//         aria-label="mailbox folders"
//       >
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{
//             keepMounted: true,
//           }}
//           sx={{
//             display: { xs: "block", md: "none" },
//             "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
//           }}
//         >
//           {drawer}
//         </Drawer>
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", md: "block" },
//             "& .MuiDrawer-paper": {
//               boxSizing: "border-box",
//               width: 250,
//               borderRight: "none",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: 3,
//           width: { md: `calc(100% - 250px)` },
//           marginTop: "64px",
//           bgcolor: "#f8f9fa",
//         }}
//       >
//         <Container maxWidth="xl" sx={{ py: 2 }}>
//           <Box sx={{ mb: 4 }} data-aos="fade-down">
//             <Typography
//               variant="h4"
//               component="h1"
//               sx={{
//                 fontWeight: "bold",
//                 color: "#2c3e50",
//                 mb: 1,
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//               }}
//             >
//               <span
//                 style={{
//                   background: "linear-gradient(to right, #6200ee, #03dac6)",
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                 }}
//               >
//                 {getTimeBasedGreeting()}, {title}
//               </span>
//               👋
//             </Typography>
//             <Typography variant="subtitle1" sx={{ color: "#7f8c8d", mb: 2 }}>
//               Teacher at {schoolName} - Here's your dashboard
//             </Typography>
//           </Box>

//           <Grid container spacing={3} sx={{ mb: 4 }} data-aos="fade-up">
//             <Grid item xs={12}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   mb: 2,
//                   p: 2,
//                   bgcolor: "white",
//                   borderRadius: "10px",
//                   boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
//                 }}
//               >
//                 <DashboardIcon sx={{ color: "#6200ee", mr: 1, fontSize: 28 }} />
//                 <Typography
//                   variant="h5"
//                   sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                 >
//                   Quick Stats
//                 </Typography>
//               </Box>
//               <Grid container spacing={2}>
//                 {[
//                   {
//                     icon: <SchoolIcon sx={{ fontSize: 30 }} />,
//                     count: stats.totalStudents,
//                     label: "Students",
//                     color: "#4CAF50",
//                     bgColor: "rgba(76, 175, 80, 0.1)",
//                   },
//                   {
//                     icon: <AssignmentIcon sx={{ fontSize: 30 }} />,
//                     count: stats.totalAssignments,
//                     label: "Assignments",
//                     color: "#2196F3",
//                     bgColor: "rgba(33, 150, 243, 0.1)",
//                   },
//                   {
//                     icon: <EventAvailableIcon sx={{ fontSize: 30 }} />,
//                     count: stats.attendance,
//                     label: "Attendance",
//                     color: "#FF9800",
//                     bgColor: "rgba(255, 152, 0, 0.1)",
//                   },
//                   {
//                     icon: <OndemandVideoIcon sx={{ fontSize: 30 }} />,
//                     count: stats.totalVideos,
//                     label: "Videos",
//                     color: "#9C27B0",
//                     bgColor: "rgba(156, 39, 176, 0.1)",
//                   },
//                 ].map((stat, index) => (
//                   <Grid item xs={12} sm={6} md={3} key={index}>
//                     <motion.div variants={statVariants} animate="pulse">
//                       <Card
//                         sx={{
//                           textAlign: "center",
//                           p: 3,
//                           boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                           bgcolor: stat.bgColor,
//                           borderRadius: "12px",
//                           borderLeft: `4px solid ${stat.color}`,
//                           height: "100%",
//                           display: "flex",
//                           flexDirection: "column",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             color: stat.color,
//                             mb: 2,
//                             display: "inline-flex",
//                             p: 1.5,
//                             bgcolor: "white",
//                             borderRadius: "50%",
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                           }}
//                         >
//                           {stat.icon}
//                         </Box>
//                         <Typography
//                           variant="h3"
//                           sx={{
//                             fontWeight: "bold",
//                             color: "#2c3e50",
//                             mb: 0.5,
//                           }}
//                         >
//                           {stat.count}
//                         </Typography>
//                         <Typography
//                           variant="subtitle1"
//                           sx={{
//                             color: "#7f8c8d",
//                             fontWeight: "medium",
//                           }}
//                         >
//                           {stat.label}
//                         </Typography>
//                       </Card>
//                     </motion.div>
//                   </Grid>
//                 ))}
//               </Grid>
//             </Grid>
//           </Grid>

//           <Grid container spacing={3}>
//             <Grid item xs={12} lg={8} data-aos="fade-right">
//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       mb: 2,
//                     }}
//                   >
//                     <ScheduleIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Scheduled Exams
//                     </Typography>
//                   </Box>

//                   {examsLoading ? (
//                     <Box sx={{ textAlign: "center", p: 3 }}>
//                       <CircularProgress color="primary" />
//                     </Box>
//                   ) : scheduledExams.length === 0 ? (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         p: 4,
//                         bgcolor: "#f8f9fa",
//                         borderRadius: "8px",
//                       }}
//                     >
//                       <img
//                         src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
//                         alt="No exams"
//                         style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
//                       />
//                       <Typography sx={{ color: "#666" }}>
//                         No scheduled exams yet
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <Grid container spacing={2}>
//                       {scheduledExams.map((exam, index) => (
//                         <Grid item xs={12} sm={6} key={exam._id}>
//                           <motion.div
//                             variants={cardVariants}
//                             initial="hidden"
//                             animate="visible"
//                             whileHover="hover"
//                           >
//                             <Card
//                               sx={{
//                                 p: 2,
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                                 bgcolor: "#fff",
//                                 borderRadius: "10px",
//                                 borderLeft: `4px solid ${
//                                   index % 2 === 0 ? "#6200ee" : "#03dac6"
//                                 }`,
//                                 cursor: "pointer",
//                               }}
//                               onClick={() =>
//                                 navigate("/teacher/update-results", {
//                                   state: {
//                                     scheduledExam: exam,
//                                     schoolId,
//                                     teacherId,
//                                   },
//                                 })
//                               }
//                             >
//                               <CardContent>
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     mb: 1,
//                                   }}
//                                 >
//                                   <EventIcon
//                                     sx={{
//                                       color:
//                                         index % 2 === 0 ? "#6200ee" : "#03dac6",
//                                       mr: 1,
//                                     }}
//                                   />
//                                   <Typography
//                                     variant="h6"
//                                     sx={{ fontWeight: "600", color: "#2c3e50" }}
//                                   >
//                                     {exam.examType}
//                                     {exam.examName
//                                       ? `: ${exam.examName}`
//                                       : ""}{" "}
//                                     ({exam.term})
//                                   </Typography>
//                                 </Box>
//                                 <Box
//                                   sx={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                     mb: 1,
//                                   }}
//                                 >
//                                   <Typography
//                                     variant="body2"
//                                     sx={{
//                                       color: "#666",
//                                       display: "flex",
//                                       alignItems: "center",
//                                       mr: 2,
//                                     }}
//                                   >
//                                     <span
//                                       style={{
//                                         display: "inline-block",
//                                         width: 8,
//                                         height: 8,
//                                         borderRadius: "50%",
//                                         bgcolor: "#4CAF50",
//                                         mr: 1,
//                                       }}
//                                     ></span>
//                                     Start:{" "}
//                                     {new Date(
//                                       exam.startDate
//                                     ).toLocaleDateString()}
//                                   </Typography>
//                                   <Typography
//                                     variant="body2"
//                                     sx={{
//                                       color: "#666",
//                                       display: "flex",
//                                       alignItems: "center",
//                                     }}
//                                   >
//                                     <span
//                                       style={{
//                                         display: "inline-block",
//                                         width: 8,
//                                         height: 8,
//                                         borderRadius: "50%",
//                                         bgcolor: "#F44336",
//                                         mr: 1,
//                                       }}
//                                     ></span>
//                                     End:{" "}
//                                     {new Date(
//                                       exam.endDate
//                                     ).toLocaleDateString()}
//                                   </Typography>
//                                 </Box>
//                                 <Chip
//                                   label={`Time Remaining: ${exam.timeRemaining}`}
//                                   color={
//                                     exam.timeRemaining === "Expired"
//                                       ? "error"
//                                       : "primary"
//                                   }
//                                   size="small"
//                                   sx={{ mt: 1 }}
//                                 />
//                               </CardContent>
//                             </Card>
//                           </motion.div>
//                         </Grid>
//                       ))}
//                     </Grid>
//                   )}
//                 </CardContent>
//               </Card>

//               <Card
//                 sx={{
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <SchoolIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       My Students
//                     </Typography>
//                   </Box>

//                   {Object.entries(learnersByClass)
//                     .slice(0, 2)
//                     .map(([className, learnersInClass]) => (
//                       <Box key={className} sx={{ mb: 3 }}>
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             mb: 1.5,
//                             p: 1,
//                             bgcolor: "#f5f5f5",
//                             borderRadius: "6px",
//                           }}
//                         >
//                           <ClassIcon sx={{ color: "#6200ee", mr: 1 }} />
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: "600", color: "#333" }}
//                           >
//                             {className}
//                           </Typography>
//                           <Chip
//                             label={`${learnersInClass.length} students`}
//                             size="small"
//                             sx={{
//                               ml: "auto",
//                               bgcolor: "#e3f2fd",
//                               color: "#1976d2",
//                             }}
//                           />
//                         </Box>

//                         <Grid container spacing={2}>
//                           {learnersInClass
//                             .slice(0, isMobile ? 1 : 2)
//                             .map((learner) => (
//                               <Grid item xs={12} sm={6} key={learner._id}>
//                                 <motion.div
//                                   variants={cardVariants}
//                                   initial="hidden"
//                                   animate="visible"
//                                   whileHover="hover"
//                                 >
//                                   <Card
//                                     sx={{
//                                       p: 2,
//                                       boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                                       bgcolor: "#fff",
//                                       borderRadius: "10px",
//                                       cursor: "pointer",
//                                     }}
//                                     onClick={() =>
//                                       navigate("/teacher/student-details", {
//                                         state: { learner },
//                                       })
//                                     }
//                                   >
//                                     <CardContent>
//                                       <Box
//                                         sx={{
//                                           display: "flex",
//                                           alignItems: "center",
//                                           mb: 2,
//                                         }}
//                                       >
//                                         <Avatar
//                                           sx={{
//                                             bgcolor: "#6200ee",
//                                             width: 48,
//                                             height: 48,
//                                             mr: 2,
//                                           }}
//                                         >
//                                           {learner.fullName.charAt(0)}
//                                         </Avatar>
//                                         <Box>
//                                           <Typography
//                                             variant="subtitle1"
//                                             sx={{
//                                               fontWeight: "600",
//                                               color: "#2c3e50",
//                                             }}
//                                           >
//                                             {learner.fullName}
//                                           </Typography>
//                                           <Typography
//                                             variant="body2"
//                                             sx={{ color: "#666" }}
//                                           >
//                                             Adm: {learner.admissionNumber}
//                                           </Typography>
//                                         </Box>
//                                       </Box>
//                                       <Divider sx={{ my: 1 }} />
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ color: "#666", mb: 1 }}
//                                       >
//                                         <strong>Parent:</strong>{" "}
//                                         {learner.parentName}
//                                       </Typography>
//                                       <Typography
//                                         variant="body2"
//                                         sx={{ color: "#666" }}
//                                       >
//                                         <strong>Contact:</strong>{" "}
//                                         {learner.parentContact}
//                                       </Typography>
//                                     </CardContent>
//                                   </Card>
//                                 </motion.div>
//                               </Grid>
//                             ))}
//                         </Grid>
//                       </Box>
//                     ))}

//                   <Box sx={{ textAlign: "center", mt: 2 }}>
//                     <Button
//                       variant="outlined"
//                       color="primary"
//                       onClick={() =>
//                         navigate("/teacher/students", { state: { schoolId } })
//                       }
//                       sx={{
//                         borderRadius: "8px",
//                         textTransform: "none",
//                         px: 4,
//                       }}
//                     >
//                       View All Students
//                     </Button>
//                   </Box>
//                 </CardContent>
//               </Card>

//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <EditIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Class Results Management
//                     </Typography>
//                   </Box>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <motion.div
//                         variants={cardVariants}
//                         initial="hidden"
//                         animate="visible"
//                         whileHover="hover"
//                       >
//                         <Card
//                           sx={{
//                             p: 2,
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                             bgcolor: "#fff",
//                             borderRadius: "10px",
//                             cursor: "pointer",
//                             borderLeft: "4px solid #6200ee",
//                           }}
//                           onClick={() =>
//                             navigate("/teacher/update-results", {
//                               state: { schoolId, teacherId },
//                             })
//                           }
//                         >
//                           <CardContent>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 mb: 1,
//                               }}
//                             >
//                               <AssignmentIcon
//                                 sx={{ color: "#6200ee", mr: 1 }}
//                               />
//                               <Typography
//                                 variant="h6"
//                                 sx={{ fontWeight: "600", color: "#2c3e50" }}
//                               >
//                                 Update Class Results
//                               </Typography>
//                             </Box>
//                             <Typography sx={{ color: "#666" }}>
//                               Submit results for an entire class
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} lg={4} data-aos="fade-left">
//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <BoltIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Quick Actions
//                     </Typography>
//                   </Box>

//                   <Grid container spacing={2}>
//                     {[
//                       {
//                         title: "Upload Video",
//                         icon: <CloudUploadIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/upload-video",
//                         color: "#4CAF50",
//                         bgColor: "rgba(76, 175, 80, 0.1)",
//                       },
//                       {
//                         title: "Video Library",
//                         icon: <VideoLibraryIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/videos",
//                         color: "#2196F3",
//                         bgColor: "rgba(33, 150, 243, 0.1)",
//                       },
//                       {
//                         title: "Upload Notes",
//                         icon: <NoteIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/upload-notes",
//                         color: "#FF9800",
//                         bgColor: "rgba(255, 152, 0, 0.1)",
//                       },
//                       {
//                         title: "Create Assignment",
//                         icon: <AssignmentIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/create-assignment",
//                         color: "#9C27B0",
//                         bgColor: "rgba(156, 39, 176, 0.1)",
//                       },
//                       {
//                         title: "View Responses",
//                         icon: <AssignmentTurnedInIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/assignments",
//                         color: "#E91E63",
//                         bgColor: "rgba(233, 30, 99, 0.1)",
//                       },
//                       {
//                         title: "Publish News",
//                         icon: <NewsIcon sx={{ fontSize: 28 }} />,
//                         path: "/teacher/publish-news",
//                         color: "#00BCD4",
//                         bgColor: "rgba(0, 188, 212, 0.1)",
//                       },
//                     ].map((action, index) => (
//                       <Grid item xs={12} sm={6} md={6} key={index}>
//                         <motion.div
//                           variants={cardVariants}
//                           initial="hidden"
//                           animate="visible"
//                           whileHover="hover"
//                         >
//                           <Card
//                             sx={{
//                               p: 2,
//                               boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                               bgcolor: action.bgColor,
//                               borderRadius: "10px",
//                               borderLeft: `4px solid ${action.color}`,
//                               cursor: "pointer",
//                               height: "100%",
//                               display: "flex",
//                               flexDirection: "column",
//                               justifyContent: "center",
//                               alignItems: "center",
//                               textAlign: "center",
//                             }}
//                             onClick={() =>
//                               navigate(action.path, {
//                                 state: { schoolId, teacherId },
//                               })
//                             }
//                           >
//                             <Box
//                               sx={{
//                                 color: action.color,
//                                 mb: 1,
//                                 p: 1.5,
//                                 bgcolor: "white",
//                                 borderRadius: "50%",
//                                 boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                               }}
//                             >
//                               {action.icon}
//                             </Box>
//                             <Typography
//                               variant="subtitle1"
//                               sx={{ fontWeight: "600", color: "#2c3e50" }}
//                             >
//                               {action.title}
//                             </Typography>
//                           </Card>
//                         </motion.div>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </CardContent>
//               </Card>

//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <VideoLibraryIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Teaching Resources
//                     </Typography>
//                   </Box>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <motion.div
//                         variants={cardVariants}
//                         initial="hidden"
//                         animate="visible"
//                         whileHover="hover"
//                       >
//                         <Card
//                           sx={{
//                             p: 2,
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                             bgcolor: "#fff",
//                             borderRadius: "10px",
//                             cursor: "pointer",
//                             borderLeft: "4px solid #6200ee",
//                           }}
//                           onClick={() =>
//                             navigate("/teacher/videos/upload", {
//                               state: { schoolId, teacherId },
//                             })
//                           }
//                         >
//                           <CardContent>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 mb: 1,
//                               }}
//                             >
//                               <CloudUploadIcon
//                                 sx={{ color: "#6200ee", mr: 1 }}
//                               />
//                               <Typography
//                                 variant="h6"
//                                 sx={{ fontWeight: "600", color: "#2c3e50" }}
//                               >
//                                 Upload Educational Video
//                               </Typography>
//                             </Box>
//                             <Typography sx={{ color: "#666" }}>
//                               Share videos with your students
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </motion.div>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <motion.div
//                         variants={cardVariants}
//                         initial="hidden"
//                         animate="visible"
//                         whileHover="hover"
//                       >
//                         <Card
//                           sx={{
//                             p: 2,
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                             bgcolor: "#fff",
//                             borderRadius: "10px",
//                             cursor: "pointer",
//                             borderLeft: "4px solid #6200ee",
//                           }}
//                           onClick={() =>
//                             navigate("/teacher/upload-video", {
//                               state: { schoolId, teacherId },
//                             })
//                           }
//                         >
//                           <CardContent>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 mb: 1,
//                               }}
//                             >
//                               <PlayCircleFilledIcon
//                                 sx={{ color: "#6200ee", mr: 1 }}
//                               />
//                               <Typography
//                                 variant="h6"
//                                 sx={{ fontWeight: "600", color: "#2c3e50" }}
//                               >
//                                 My Video Library
//                               </Typography>
//                             </Box>
//                             <Typography sx={{ color: "#666" }}>
//                               View and manage your videos
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>

//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <TrendingUpIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Class Performance
//                     </Typography>
//                   </Box>

//                   <Grid container spacing={2}>
//                     <Grid item xs={12}>
//                       <motion.div
//                         variants={cardVariants}
//                         initial="hidden"
//                         animate="visible"
//                         whileHover="hover"
//                       >
//                         <Card
//                           sx={{
//                             p: 2,
//                             boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                             bgcolor: "#fff",
//                             borderRadius: "10px",
//                             cursor: "pointer",
//                             borderLeft: "4px solid #6200ee",
//                           }}
//                           onClick={() =>
//                             navigate("/teacher/performance", {
//                               state: { schoolId, teacherId },
//                             })
//                           }
//                         >
//                           <CardContent>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 mb: 1,
//                               }}
//                             >
//                               <TrendingUpIcon
//                                 sx={{ color: "#6200ee", mr: 1 }}
//                               />
//                               <Typography
//                                 variant="h6"
//                                 sx={{ fontWeight: "600", color: "#2c3e50" }}
//                               >
//                                 Performance Overview
//                               </Typography>
//                             </Box>
//                             <Typography sx={{ color: "#666", mb: 1 }}>
//                               <strong>Average Grade:</strong> 85%
//                             </Typography>
//                             <Typography sx={{ color: "#666" }}>
//                               <strong>Attendance:</strong> 95%
//                             </Typography>
//                           </CardContent>
//                         </Card>
//                       </motion.div>
//                     </Grid>
//                   </Grid>
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} md={6} data-aos="fade-up">
//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <PublicIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       National Events
//                     </Typography>
//                   </Box>

//                   {nationalEvents.length === 0 ? (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         p: 4,
//                         bgcolor: "#f8f9fa",
//                         borderRadius: "8px",
//                       }}
//                     >
//                       <img
//                         src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
//                         alt="No national events"
//                         style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
//                       />
//                       <Typography sx={{ color: "#666" }}>
//                         No national events available
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <>
//                       <Grid container spacing={2}>
//                         {nationalEvents
//                           .slice(0, isMobile ? 1 : 2)
//                           .map((event) => (
//                             <Grid item xs={12} key={event._id}>
//                               <motion.div
//                                 variants={cardVariants}
//                                 initial="hidden"
//                                 animate="visible"
//                                 whileHover="hover"
//                               >
//                                 <Card
//                                   sx={{
//                                     p: 2,
//                                     boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                                     bgcolor: "#fff",
//                                     borderRadius: "10px",
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() =>
//                                     navigate("/teacher/events/details", {
//                                       state: { event, schoolId, teacherId },
//                                     })
//                                   }
//                                 >
//                                   <CardContent>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <StarIcon
//                                         sx={{ color: "#6200ee", mr: 1 }}
//                                       />
//                                       <Typography
//                                         variant="h6"
//                                         sx={{
//                                           fontWeight: "600",
//                                           color: "#2c3e50",
//                                         }}
//                                       >
//                                         {event.eventName}
//                                       </Typography>
//                                     </Box>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666", mb: 1 }}
//                                     >
//                                       <strong>Date:</strong>{" "}
//                                       {new Date(
//                                         event.dateTime
//                                       ).toLocaleDateString()}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666", mb: 1 }}
//                                     >
//                                       <strong>Venue:</strong> {event.venue}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666" }}
//                                     >
//                                       <strong>Organizer:</strong>{" "}
//                                       {event.organizer}
//                                     </Typography>
//                                   </CardContent>
//                                 </Card>
//                               </motion.div>
//                             </Grid>
//                           ))}
//                       </Grid>

//                       {nationalEvents.length > 0 && (
//                         <Box sx={{ textAlign: "center", mt: 2 }}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() =>
//                               navigate("/teacher/events", {
//                                 state: { schoolId, teacherId },
//                               })
//                             }
//                             sx={{
//                               borderRadius: "8px",
//                               textTransform: "none",
//                               px: 4,
//                             }}
//                           >
//                             View All National Events
//                           </Button>
//                         </Box>
//                       )}
//                     </>
//                   )}
//                 </CardContent>
//               </Card>
//             </Grid>

//             <Grid item xs={12} md={6} data-aos="fade-up">
//               <Card
//                 sx={{
//                   mb: 3,
//                   boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
//                   borderRadius: "12px",
//                 }}
//               >
//                 <CardContent>
//                   <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
//                     <EmojiEventsIcon
//                       sx={{
//                         color: "white",
//                         mr: 1,
//                         bgcolor: "#6200ee",
//                         p: 1,
//                         borderRadius: "8px",
//                         fontSize: 28,
//                       }}
//                     />
//                     <Typography
//                       variant="h5"
//                       sx={{ fontWeight: "bold", color: "#2c3e50" }}
//                     >
//                       Scholarships & Opportunities
//                     </Typography>
//                   </Box>

//                   {scholarshipsLoading ? (
//                     <Box sx={{ textAlign: "center", p: 3 }}>
//                       <CircularProgress color="primary" />
//                     </Box>
//                   ) : scholarships.length === 0 ? (
//                     <Box
//                       sx={{
//                         textAlign: "center",
//                         p: 4,
//                         bgcolor: "#f8f9fa",
//                         borderRadius: "8px",
//                       }}
//                     >
//                       <img
//                         src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
//                         alt="No scholarships"
//                         style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
//                       />
//                       <Typography sx={{ color: "#666" }}>
//                         No scholarships available
//                       </Typography>
//                     </Box>
//                   ) : (
//                     <>
//                       <Grid container spacing={2}>
//                         {scholarships
//                           .slice(0, isMobile ? 1 : 2)
//                           .map((scholarship) => (
//                             <Grid item xs={12} key={scholarship._id}>
//                               <motion.div
//                                 variants={cardVariants}
//                                 initial="hidden"
//                                 animate="visible"
//                                 whileHover="hover"
//                               >
//                                 <Card
//                                   sx={{
//                                     p: 2,
//                                     boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
//                                     bgcolor: "#fff",
//                                     borderRadius: "10px",
//                                     cursor: "pointer",
//                                   }}
//                                   onClick={() =>
//                                     navigate("/teacher/scholarships/details", {
//                                       state: {
//                                         scholarship,
//                                         schoolId,
//                                         teacherId,
//                                       },
//                                     })
//                                   }
//                                 >
//                                   <CardContent>
//                                     <Box
//                                       sx={{
//                                         display: "flex",
//                                         alignItems: "center",
//                                         mb: 1,
//                                       }}
//                                     >
//                                       <WorkspacesIcon
//                                         sx={{ color: "#6200ee", mr: 1 }}
//                                       />
//                                       <Typography
//                                         variant="h6"
//                                         sx={{
//                                           fontWeight: "600",
//                                           color: "#2c3e50",
//                                         }}
//                                       >
//                                         {scholarship.title}
//                                       </Typography>
//                                     </Box>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666", mb: 1 }}
//                                     >
//                                       <strong>Type:</strong> {scholarship.type}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666", mb: 1 }}
//                                     >
//                                       <strong>Organization:</strong>{" "}
//                                       {scholarship.hostOrganization}
//                                     </Typography>
//                                     <Typography
//                                       variant="body2"
//                                       sx={{ color: "#666" }}
//                                     >
//                                       <strong>Deadline:</strong>{" "}
//                                       {new Date(
//                                         scholarship.deadline
//                                       ).toLocaleDateString()}
//                                     </Typography>
//                                   </CardContent>
//                                 </Card>
//                               </motion.div>
//                             </Grid>
//                           ))}
//                       </Grid>

//                       {scholarships.length > 0 && (
//                         <Box sx={{ textAlign: "center", mt: 2 }}>
//                           <Button
//                             variant="outlined"
//                             color="primary"
//                             onClick={() =>
//                               navigate("/teacher/scholarships", {
//                                 state: { schoolId, teacherId },
//                               })
//                             }
//                             sx={{
//                               borderRadius: "8px",
//                               textTransform: "none",
//                               px: 4,
//                             }}
//                           >
//                             View All Scholarships
//                           </Button>
//                         </Box>
//                       )}
//                     </>
//                   )}
//                 </CardContent>
//               </Card>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {isMobile && (
//         <Paper
//           sx={{
//             position: "fixed",
//             bottom: 0,
//             left: 0,
//             right: 0,
//             zIndex: theme.zIndex.appBar,
//             display: "flex",
//             justifyContent: "space-around",
//             alignItems: "center",
//             py: 1,
//             px: 0,
//             borderTop: "1px solid #eee",
//             borderRadius: 0,
//           }}
//           elevation={3}
//         >
//           {[
//             {
//               icon: <HomeIcon />,
//               label: "Home",
//               action: () => navigate("/teacher"),
//               path: "/teacher",
//             },
//             {
//               icon: <PersonIcon />,
//               label: "Students",
//               action: () =>
//                 navigate("/teacher/students", { state: { schoolId } }),
//               path: "/teacher/students",
//             },
//             {
//               icon: <VideoLibraryIcon />,
//               label: "Videos",
//               action: () =>
//                 navigate("/teacher/videos", { state: { schoolId, teacherId } }),
//               path: "/teacher/videos",
//             },
//             {
//               icon: <NoteIcon />,
//               label: "Notes",
//               action: () =>
//                 navigate("/teacher/notes", { state: { schoolId, teacherId } }),
//               path: "/teacher/notes",
//             },
//           ].map((item, index) => (
//             <Button
//               key={index}
//               sx={{
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 minWidth: "auto",
//                 color: pathname === item.path ? "#6200ee" : "#666",
//                 textTransform: "none",
//                 p: 1,
//               }}
//               onClick={item.action}
//             >
//               <IconButton sx={{ color: "inherit" }}>{item.icon}</IconButton>
//               <Typography variant="caption" sx={{ fontSize: "0.65rem" }}>
//                 {item.label}
//               </Typography>
//             </Button>
//           ))}
//         </Paper>
//       )}
//     </Box>
//   );
// };

// export default TeacherDashboard;


import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { useTeacherAuth } from "../auth/TeacherAuthContext";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  CircularProgress,
  IconButton,
  Divider,
  Container,
  AppBar,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Badge,
  useMediaQuery,
  useTheme,
  Paper,
  Chip,
} from "@mui/material";
import {
  School as SchoolIcon,
  People as PeopleIcon,
  Person as PersonIcon,
  Event as EventIcon,
  Schedule as ScheduleIcon,
  Edit as EditIcon,
  NewReleases as NewsIcon,
  Bolt as BoltIcon,
  Public as PublicIcon,
  Workspaces as WorkspacesIcon,
  Assessment as AssessmentIcon,
  Forum as ForumIcon,
  Menu as MenuIcon,
  Home as HomeIcon,
  Star as StarIcon,
  Notifications as NotificationsIcon,
  AccountCircle as AccountCircleIcon,
  Class as ClassIcon,
  Book as BookIcon,
  Groups as GroupsIcon,
  Assignment as AssignmentIcon,
  EmojiEvents as EmojiEventsIcon,
  Dashboard as DashboardIcon,
  BarChart as BarChartIcon,
  Settings as SettingsIcon,
  ExitToApp as ExitToAppIcon,
  VideoLibrary as VideoLibraryIcon,
  CloudUpload as CloudUploadIcon,
  PlayCircleFilled as PlayCircleFilledIcon,
  EventAvailable as EventAvailableIcon,
  OndemandVideo as OndemandVideoIcon,
  Note as NoteIcon,
  AssignmentTurnedIn as AssignmentTurnedInIcon,
  TrendingUp as TrendingUpIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import AOS from "aos";
import "aos/dist/aos.css";

const TeacherDashboard = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { teacherData, logout } = useTeacherAuth();
  const schoolId = teacherData?.schoolId;
  const { teacherId, teacherName, gender, schoolName } = teacherData || {};

  const [learners, setLearners] = useState([]);
  const [stats, setStats] = useState({
    totalStudents: 0,
    totalAssignments: 0,
    totalVideos: 0,
    attendance: "95%",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statsLoading, setStatsLoading] = useState(true);
  const [nationalEvents, setNationalEvents] = useState([]);
  const [scholarships, setScholarships] = useState([]);
  const [scholarshipsLoading, setScholarshipsLoading] = useState(true);
  const [scheduledExams, setScheduledExams] = useState([]);
  const [examsLoading, setExamsLoading] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Determine the title based on gender
  const title = gender === "M" ? `Mr. ${teacherName}` : `Ms. ${teacherName}`;

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    return hour < 12
      ? "Good Morning"
      : hour < 17
      ? "Good Afternoon"
      : "Good Evening";
  };

  const calculateTimeRemaining = (endDate) => {
    if (!endDate) return "N/A";
    const now = new Date();
    const end = new Date(endDate);
    const diff = end - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      if (!teacherId || !schoolId) {
        throw new Error("Missing teacher or school information");
      }

      const [
        learnersRes,
        assignmentsRes,
        videosRes,
        nationalEventsRes,
        scholarshipsRes,
        scheduledExamsRes,
      ] = await Promise.all([
        axios.get("https://kidsm.vercel.app/api/schools/learners", {
          params: { schoolId },
        }),
        axios.get(
          `https://kidsm.vercel.app/api/schools/${schoolId}/teachers/${teacherId}/assignments/count`,
          { params: { schoolId } }
        ),
        axios.get(
          `https://kidsm.vercel.app/api/schools/${schoolId}/teachers/${teacherId}/videos/stats`,
          { params: { schoolId } }
        ),
        axios.get(
          "https://kidsm.vercel.app/api/schools/latest-amplified-events"
        ),
        axios.get("https://kidsm.vercel.app/api/schools/latest-scholarships"),
        axios.get("https://kidsm.vercel.app/api/schools/scheduled-exams", {
          params: { schoolId },
        }),
      ]);

      setLearners(learnersRes.data || []);
      setNationalEvents(nationalEventsRes.data || []);
      setScholarships(scholarshipsRes.data || []);
      setScheduledExams(
        (scheduledExamsRes.data.exams || []).map((exam) => ({
          ...exam,
          timeRemaining: calculateTimeRemaining(exam.endDate),
        }))
      );

      setStats({
        totalStudents: learnersRes.data?.length || 0,
        totalAssignments: assignmentsRes.data?.count || 0,
        totalVideos: videosRes.data?.totalVideos || 0,
        attendance: "95%",
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setError(error.message || "Failed to load dashboard data");
      setLearners([]);
      setNationalEvents([]);
      setScholarships([]);
      setScheduledExams([]);
      setStats({
        totalStudents: 0,
        totalAssignments: 0,
        totalVideos: 0,
        attendance: "0%",
      });
    } finally {
      setLoading(false);
      setStatsLoading(false);
      setScholarshipsLoading(false);
      setExamsLoading(false);
    }
  };

  useEffect(() => {
    console.log("School ID:", schoolId);
    if (teacherId && schoolId) {
      fetchData();
      const interval = setInterval(() => {
        setScheduledExams((prevExams) =>
          prevExams.map((exam) => ({
            ...exam,
            timeRemaining: calculateTimeRemaining(exam.endDate),
          }))
        );
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [teacherId, schoolId]);

  const groupLearnersByClass = (learners) => {
    return learners.reduce((acc, learner) => {
      const { class: className } = learner;
      if (!acc[className]) acc[className] = [];
      acc[className].push(learner);
      return acc;
    }, {});
  };

  const learnersByClass = groupLearnersByClass(learners);

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.9, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" },
    },
    hover: { scale: 1.05, transition: { duration: 0.2 } },
  };

  const statVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: { repeat: Infinity, duration: 2 },
    },
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    logout();
    navigate("/teacher/login");
  };

  const drawer = (
    <Box sx={{ width: 250, bgcolor: "background.paper", height: "100%" }}>
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#6200ee",
          color: "white",
        }}
      >
        <SchoolIcon sx={{ mr: 1, fontSize: 32 }} />
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      </Box>
      <Divider />
      <List>
        {[
          { text: "Dashboard", icon: <DashboardIcon />, path: "/teacher" },
          {
            text: "My Students",
            icon: <PersonIcon />,
            path: "/teacher/students",
            state: { schoolId },
          },
          {
            text: "Update Results",
            icon: <EditIcon />,
            path: "/teacher/update-results",
            state: { schoolId, teacherId },
          },
          {
            text: "Video Library",
            icon: <VideoLibraryIcon />,
            path: "/teacher/videos",
            state: { schoolId, teacherId },
          },
          {
            text: "Upload Notes",
            icon: <NoteIcon />,
            path: "/teacher/upload-notes",
            state: { schoolId, teacherId },
          },
          {
            text: "Assignments",
            icon: <AssignmentIcon />,
            path: "/teacher/assignments",
            state: { schoolId, teacherId },
          },
          {
            text: "Create Assignment",
            icon: <AssignmentTurnedInIcon />,
            path: "/teacher/create-assignment",
            state: { schoolId, teacherId },
          },
          {
            text: "Teacher Resources",
            icon: <DescriptionIcon />,
            path: "/teacher/resources",
            state: { schoolId, teacherId },
          },
          {
            text: "Class Performance",
            icon: <TrendingUpIcon />,
            path: "/teacher/school-performance",
            state: { schoolId, teacherId },
          },
          {
            text: "National Events",
            icon: <PublicIcon />,
            path: "/teacher/amplified-events",
            state: { schoolId, teacherId },
          },
          {
            text: "Scholarships",
            icon: <EmojiEventsIcon />,
            path: "/teacher/scholarships",
            state: { schoolId, teacherId },
          },
          
          { text: "Logout", icon: <ExitToAppIcon />, action: handleLogout },
        ].map((item, index) => (
          <ListItem
            button
            key={index}
            onClick={() =>
              item.action
                ? item.action()
                : navigate(item.path, { state: item.state })
            }
            sx={{
              "&:hover": { bgcolor: "#f5f5f5" },
              borderRadius: 1,
              mx: 1,
              my: 0.5,
            }}
          >
            <ListItemIcon sx={{ color: "#6200ee" }}>{item.icon}</ListItemIcon>
            <ListItemText
              primary={item.text}
              primaryTypographyProps={{ fontWeight: "medium" }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        }}
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        >
          <CircularProgress size={80} thickness={4} color="primary" />
        </motion.div>
        <Typography
          variant="h6"
          sx={{
            mt: 3,
            color: "#2c3e50",
            fontWeight: "bold",
            background: "linear-gradient(to right, #6200ee, #03dac6)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Loading your teacher dashboard...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          p: 3,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h5"
          color="error"
          sx={{ mb: 2, fontWeight: "bold" }}
        >
          Error Loading Dashboard
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          {error}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={fetchData}
          sx={{ mb: 2 }}
        >
          Retry
        </Button>
        <Button variant="outlined" color="primary" onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f8f9fa" }}>
      <AppBar
        position="fixed"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          bgcolor: "white",
          color: "#2c3e50",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: "none" }, color: "#6200ee" }}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            <SchoolIcon sx={{ color: "#6200ee", mr: 1, fontSize: 32 }} />
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{
                fontWeight: "bold",
                background: "linear-gradient(to right, #6200ee, #03dac6)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {title} - {schoolName}
            </Typography>
          </Box>

          <Box
            sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}
          >
            <IconButton size="large" color="inherit" sx={{ color: "#6200ee" }}>
              <Badge badgeContent={notifications.length} color="error">
                <NotificationsIcon />
              </Badge>
            </IconButton>
            <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-haspopup="true"
              color="inherit"
              sx={{ color: "#6200ee" }}
              onClick={() =>
                navigate("/teacher/profile", { state: { schoolId, teacherId } })
              }
            >
              <AccountCircleIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{ width: { md: 250 }, flexShrink: { md: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: 250 },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: 250,
              borderRight: "none",
            }}
          }
          open
        >
          {drawer}
        </Drawer>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          width: { md: `calc(100% - 250px)` },
          marginTop: "64px",
          bgcolor: "#f8f9fa",
        }}
      >
        <Container maxWidth="xl" sx={{ py: 2 }}>
          <Box sx={{ mb: 4 }} data-aos="fade-down">
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: "bold",
                color: "#2c3e50",
                mb: 1,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span
                style={{
                  background: "linear-gradient(to right, #6200ee, #03dac6)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {getTimeBasedGreeting()}, {title}
              </span>
              👋
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#7f8c8d", mb: 2 }}>
              Teacher at {schoolName} - Here's your dashboard
            </Typography>
          </Box>

          <Grid container spacing={3} sx={{ mb: 4 }} data-aos="fade-up">
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  mb: 2,
                  p: 2,
                  bgcolor: "white",
                  borderRadius: "10px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                }}
              >
                <DashboardIcon sx={{ color: "#6200ee", mr: 1, fontSize: 28 }} />
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", color: "#2c3e50" }}
                >
                  Quick Stats
                </Typography>
              </Box>
              <Grid container spacing={2}>
                {[
                  {
                    icon: <SchoolIcon sx={{ fontSize: 30 }} />,
                    count: stats.totalStudents,
                    label: "Students",
                    color: "#4CAF50",
                    bgColor: "rgba(76, 175, 80, 0.1)",
                  },
                  {
                    icon: <AssignmentIcon sx={{ fontSize: 30 }} />,
                    count: stats.totalAssignments,
                    label: "Assignments",
                    color: "#2196F3",
                    bgColor: "rgba(33, 150, 243, 0.1)",
                  },
                  {
                    icon: <EventAvailableIcon sx={{ fontSize: 30 }} />,
                    count: stats.attendance,
                    label: "Attendance",
                    color: "#FF9800",
                    bgColor: "rgba(255, 152, 0, 0.1)",
                  },
                  {
                    icon: <OndemandVideoIcon sx={{ fontSize: 30 }} />,
                    count: stats.totalVideos,
                    label: "Videos",
                    color: "#9C27B0",
                    bgColor: "rgba(156, 39, 176, 0.1)",
                  },
                ].map((stat, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <motion.div variants={statVariants} animate="pulse">
                      <Card
                        sx={{
                          textAlign: "center",
                          p: 3,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                          bgcolor: stat.bgColor,
                          borderRadius: "12px",
                          borderLeft: `4px solid ${stat.color}`,
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <Box
                          sx={{
                            color: stat.color,
                            mb: 2,
                            display: "inline-flex",
                            p: 1.5,
                            bgcolor: "white",
                            borderRadius: "50%",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          {stat.icon}
                        </Box>
                        <Typography
                          variant="h3"
                          sx={{
                            fontWeight: "bold",
                            color: "#2c3e50",
                            mb: 0.5,
                          }}
                        >
                          {stat.count}
                        </Typography>
                        <Typography
                          variant="subtitle1"
                          sx={{
                            color: "#7f8c8d",
                            fontWeight: "medium",
                          }}
                        >
                          {stat.label}
                        </Typography>
                      </Card>
                    </motion.div>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12} lg={8} data-aos="fade-right">
              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <ScheduleIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      Scheduled Exams
                    </Typography>
                  </Box>

                  {examsLoading ? (
                    <Box sx={{ textAlign: "center", p: 3 }}>
                      <CircularProgress color="primary" />
                    </Box>
                  ) : scheduledExams.length === 0 ? (
                    <Box
                      sx={{
                        textAlign: "center",
                        p: 4,
                        bgcolor: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/4076/4076478.png"
                        alt="No exams"
                        style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
                      />
                      <Typography sx={{ color: "#666" }}>
                        No scheduled exams yet
                      </Typography>
                    </Box>
                  ) : (
                    <Grid container spacing={2}>
                      {scheduledExams.map((exam, index) => (
                        <Grid item xs={12} sm={6} key={exam._id}>
                          <motion.div
                            variants={cardVariants}
                            initial="hidden"
                            animate="visible"
                            whileHover="hover"
                          >
                            <Card
                              sx={{
                                p: 2,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                bgcolor: "#fff",
                                borderRadius: "10px",
                                borderLeft: `4px solid ${
                                  index % 2 === 0 ? "#6200ee" : "#03dac6"
                                }`,
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate("/teacher/update-results", {
                                  state: {
                                    scheduledExam: exam,
                                    schoolId,
                                    teacherId,
                                  },
                                })
                              }
                            >
                              <CardContent>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 1,
                                  }}
                                >
                                  <EventIcon
                                    sx={{
                                      color:
                                        index % 2 === 0 ? "#6200ee" : "#03dac6",
                                      mr: 1,
                                    }}
                                  />
                                  <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "600", color: "#2c3e50" }}
                                  >
                                    {exam.examType}
                                    {exam.examName
                                      ? `: ${exam.examName}`
                                      : ""}{" "}
                                    ({exam.term})
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    mb: 1,
                                  }}
                                >
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#666",
                                      display: "flex",
                                      alignItems: "center",
                                      mr: 2,
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        bgcolor: "#4CAF50",
                                        mr: 1,
                                      }}
                                    ></span>
                                    Start:{" "}
                                    {new Date(
                                      exam.startDate
                                    ).toLocaleDateString()}
                                  </Typography>
                                  <Typography
                                    variant="body2"
                                    sx={{
                                      color: "#666",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: "inline-block",
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        bgcolor: "#F44336",
                                        mr: 1,
                                      }}
                                    ></span>
                                    End:{" "}
                                    {new Date(
                                      exam.endDate
                                    ).toLocaleDateString()}
                                  </Typography>
                                </Box>
                                <Chip
                                  label={`Time Remaining: ${exam.timeRemaining}`}
                                  color={
                                    exam.timeRemaining === "Expired"
                                      ? "error"
                                      : "primary"
                                  }
                                  size="small"
                                  sx={{ mt: 1 }}
                                />
                              </CardContent>
                            </Card>
                          </motion.div>
                        </Grid>
                      ))}
                    </Grid>
                  )}
                </CardContent>
              </Card>

              <Card
                sx={{
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <SchoolIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      My Students
                    </Typography>
                  </Box>

                  {Object.entries(learnersByClass)
                    .slice(0, 2)
                    .map(([className, learnersInClass]) => (
                      <Box key={className} sx={{ mb: 3 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 1.5,
                            p: 1,
                            bgcolor: "#f5f5f5",
                            borderRadius: "6px",
                          }}
                        >
                          <ClassIcon sx={{ color: "#6200ee", mr: 1 }} />
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: "600", color: "#333" }}
                          >
                            {className}
                          </Typography>
                          <Chip
                            label={`${learnersInClass.length} students`}
                            size="small"
                            sx={{
                              ml: "auto",
                              bgcolor: "#e3f2fd",
                              color: "#1976d2",
                            }}
                          />
                        </Box>

                        <Grid container spacing={2}>
                          {learnersInClass
                            .slice(0, isMobile ? 1 : 2)
                            .map((learner) => (
                              <Grid item xs={12} sm={6} key={learner._id}>
                                <motion.div
                                  variants={cardVariants}
                                  initial="hidden"
                                  animate="visible"
                                  whileHover="hover"
                                >
                                  <Card
                                    sx={{
                                      p: 2,
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                      bgcolor: "#fff",
                                      borderRadius: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      navigate("/teacher/student-details", {
                                        state: { learner },
                                      })
                                    }
                                  >
                                    <CardContent>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          mb: 2,
                                        }}
                                      >
                                        <Avatar
                                          sx={{
                                            bgcolor: "#6200ee",
                                            width: 48,
                                            height: 48,
                                            mr: 2,
                                          }}
                                        >
                                          {learner.fullName.charAt(0)}
                                        </Avatar>
                                        <Box>
                                          <Typography
                                            variant="subtitle1"
                                            sx={{
                                              fontWeight: "600",
                                              color: "#2c3e50",
                                            }}
                                          >
                                            {learner.fullName}
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            sx={{ color: "#666" }}
                                          >
                                            Adm: {learner.admissionNumber}
                                          </Typography>
                                        </Box>
                                      </Box>
                                      <Divider sx={{ my: 1 }} />
                                      <Typography
                                        variant="body2"
                                        sx={{ color: "#666", mb: 1 }}
                                      >
                                        <strong>Parent:</strong>{" "}
                                        {learner.parentName}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        sx={{ color: "#666" }}
                                      >
                                        <strong>Contact:</strong>{" "}
                                        {learner.parentContact}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                </motion.div>
                              </Grid>
                            ))}
                        </Grid>
                      </Box>
                    ))}

                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      onClick={() =>
                        navigate("/teacher/students", { state: { schoolId } })
                      }
                      sx={{
                        borderRadius: "8px",
                        textTransform: "none",
                        px: 4,
                      }}
                    >
                      View All Students
                    </Button>
                  </Box>
                </CardContent>
              </Card>

              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <EditIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      Class Results Management
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            bgcolor: "#fff",
                            borderRadius: "10px",
                            cursor: "pointer",
                            borderLeft: "4px solid #6200ee",
                          }}
                          onClick={() =>
                            navigate("/teacher/update-results", {
                              state: { schoolId, teacherId },
                            })
                          }
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <AssignmentIcon
                                sx={{ color: "#6200ee", mr: 1 }}
                              />
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600", color: "#2c3e50" }}
                              >
                                Update Class Results
                              </Typography>
                            </Box>
                            <Typography sx={{ color: "#666" }}>
                              Submit results for an entire class
                            </Typography>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} lg={4} data-aos="fade-left">
              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <BoltIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      Quick Actions
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    {[
                      {
                        title: "Upload Video",
                        icon: <CloudUploadIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/upload-video",
                        color: "#4CAF50",
                        bgColor: "rgba(76, 175, 80, 0.1)",
                      },
                      {
                        title: "Video Library",
                        icon: <VideoLibraryIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/videos",
                        color: "#2196F3",
                        bgColor: "rgba(33, 150, 243, 0.1)",
                      },
                      {
                        title: "Upload Notes",
                        icon: <NoteIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/upload-notes",
                        color: "#FF9800",
                        bgColor: "rgba(255, 152, 0, 0.1)",
                      },
                      {
                        title: "Create Assignment",
                        icon: <AssignmentIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/create-assignment",
                        color: "#9C27B0",
                        bgColor: "rgba(156, 39, 176, 0.1)",
                      },
                      {
                        title: "View Responses",
                        icon: <AssignmentTurnedInIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/assignments",
                        color: "#E91E63",
                        bgColor: "rgba(233, 30, 99, 0.1)",
                      },
                      {
                        title: "Teacher Resources",
                        icon: <DescriptionIcon sx={{ fontSize: 28 }} />,
                        path: "/teacher/resources",
                        color: "#00BCD4",
                        bgColor: "rgba(0, 188, 212, 0.1)",
                      },
                    ].map((action, index) => (
                      <Grid item xs={12} sm={6} md={6} key={index}>
                        <motion.div
                          variants={cardVariants}
                          initial="hidden"
                          animate="visible"
                          whileHover="hover"
                        >
                          <Card
                            sx={{
                              p: 2,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                              bgcolor: action.bgColor,
                              borderRadius: "10px",
                              borderLeft: `4px solid ${action.color}`,
                              cursor: "pointer",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                            onClick={() =>
                              navigate(action.path, {
                                state: { schoolId, teacherId },
                              })
                            }
                          >
                            <Box
                              sx={{
                                color: action.color,
                                mb: 1,
                                p: 1.5,
                                bgcolor: "white",
                                borderRadius: "50%",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                              }}
                            >
                              {action.icon}
                            </Box>
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "600", color: "#2c3e50" }}
                            >
                              {action.title}
                            </Typography>
                          </Card>
                        </motion.div>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>

              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <DescriptionIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      Teaching Resources
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            bgcolor: "#fff",
                            borderRadius: "10px",
                            cursor: "pointer",
                            borderLeft: "4px solid #6200ee",
                          }}
                          onClick={() =>
                            navigate("/teacher/resources", {
                              state: { schoolId, teacherId },
                            })
                          }
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <DescriptionIcon
                                sx={{ color: "#6200ee", mr: 1 }}
                              />
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600", color: "#2c3e50" }}
                              >
                                View Resources
                              </Typography>
                            </Box>
                            <Typography sx={{ color: "#666" }}>
                              Access educational materials
                            </Typography>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                    <Grid item xs={12}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            bgcolor: "#fff",
                            borderRadius: "10px",
                            cursor: "pointer",
                            borderLeft: "4px solid #6200ee",
                          }}
                          onClick={() =>
                            navigate("/teacher/upload-video", {
                              state: { schoolId, teacherId },
                            })
                          }
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <CloudUploadIcon
                                sx={{ color: "#6200ee", mr: 1 }}
                              />
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600", color: "#2c3e50" }}
                              >
                                Upload Educational Video
                              </Typography>
                            </Box>
                            <Typography sx={{ color: "#666" }}>
                              Share videos with your students
                            </Typography>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                    <Grid item xs={12}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            bgcolor: "#fff",
                            borderRadius: "10px",
                            cursor: "pointer",
                            borderLeft: "4px solid #6200ee",
                          }}
                          onClick={() =>
                            navigate("/teacher/videos", {
                              state: { schoolId, teacherId },
                            })
                          }
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <PlayCircleFilledIcon
                                sx={{ color: "#6200ee", mr: 1 }}
                              />
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600", color: "#2c3e50" }}
                              >
                                My Video Library
                              </Typography>
                            </Box>
                            <Typography sx={{ color: "#666" }}>
                              View and manage your videos
                            </Typography>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <TrendingUpIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      School Performance
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <motion.div
                        variants={cardVariants}
                        initial="hidden"
                        animate="visible"
                        whileHover="hover"
                      >
                        <Card
                          sx={{
                            p: 2,
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            bgcolor: "#fff",
                            borderRadius: "10px",
                            cursor: "pointer",
                            borderLeft: "4px solid #6200ee",
                          }}
                          onClick={() =>
                            navigate("/teacher/school-performance", {
                              state: { schoolId, teacherId },
                            })
                          }
                        >
                          <CardContent>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <TrendingUpIcon
                                sx={{ color: "#6200ee", mr: 1 }}
                              />
                              <Typography
                                variant="h6"
                                sx={{ fontWeight: "600", color: "#2c3e50" }}
                              >
                                Performance Overview
                              </Typography>
                            </Box>
                            <Typography sx={{ color: "#666", mb: 1 }}>
                              <strong>Average Grade:</strong> 85%
                            </Typography>
                            <Typography sx={{ color: "#666" }}>
                              <strong>Attendance:</strong> 95%
                            </Typography>
                          </CardContent>
                        </Card>
                      </motion.div>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up">
              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <PublicIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      National Events
                    </Typography>
                  </Box>

                  {nationalEvents.length === 0 ? (
                    <Box
                      sx={{
                        textAlign: "center",
                        p: 4,
                        bgcolor: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
                        alt="No national events"
                        style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
                      />
                      <Typography sx={{ color: "#666" }}>
                        No national events available
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Grid container spacing={2}>
                        {nationalEvents
                          .slice(0, isMobile ? 1 : 2)
                          .map((event) => (
                            <Grid item xs={12} key={event._id}>
                              <motion.div
                                variants={cardVariants}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                              >
                                <Card
                                  sx={{
                                    p: 2,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                    bgcolor: "#fff",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    navigate("/teacher/amplified-event-details", {
                                      state: { event, schoolId, teacherId },
                                    })
                                  }
                                >
                                  <CardContent>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1,
                                      }}
                                    >
                                      <StarIcon
                                        sx={{ color: "#6200ee", mr: 1 }}
                                      />
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          fontWeight: "600",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        {event.eventName}
                                      </Typography>
                                    </Box>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666", mb: 1 }}
                                    >
                                      <strong>Date:</strong>{" "}
                                      {new Date(
                                        event.dateTime
                                      ).toLocaleDateString()}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666", mb: 1 }}
                                    >
                                      <strong>Venue:</strong> {event.venue}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666" }}
                                    >
                                      <strong>Organizer:</strong>{" "}
                                      {event.organizer}
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </motion.div>
                            </Grid>
                          ))}
                      </Grid>

                      {nationalEvents.length > 0 && (
                        <Box sx={{ textAlign: "center", mt: 2 }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() =>
                              navigate("/teacher/amplified-events", {
                                state: { schoolId, teacherId },
                              })
                            }
                            sx={{
                              borderRadius: "8px",
                              textTransform: "none",
                              px: 4,
                            }}
                          >
                            View All National Events
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up">
              <Card
                sx={{
                  mb: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  borderRadius: "12px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                    <EmojiEventsIcon
                      sx={{
                        color: "white",
                        mr: 1,
                        bgcolor: "#6200ee",
                        p: 1,
                        borderRadius: "8px",
                        fontSize: 28,
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", color: "#2c3e50" }}
                    >
                      Scholarships & Opportunities
                    </Typography>
                  </Box>

                  {scholarshipsLoading ? (
                    <Box sx={{ textAlign: "center", p: 3 }}>
                      <CircularProgress color="primary" />
                    </Box>
                  ) : scholarships.length === 0 ? (
                    <Box
                      sx={{
                        textAlign: "center",
                        p: 4,
                        bgcolor: "#f8f9fa",
                        borderRadius: "8px",
                      }}
                    >
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/3132/3132693.png"
                        alt="No scholarships"
                        style={{ width: 100, opacity: 0.7, marginBottom: 16 }}
                      />
                      <Typography sx={{ color: "#666" }}>
                        No scholarships available
                      </Typography>
                    </Box>
                  ) : (
                    <>
                      <Grid container spacing={2}>
                        {scholarships
                          .slice(0, isMobile ? 1 : 2)
                          .map((scholarship) => (
                            <Grid item xs={12} key={scholarship._id}>
                              <motion.div
                                variants={cardVariants}
                                initial="hidden"
                                animate="visible"
                                whileHover="hover"
                              >
                                <Card
                                  sx={{
                                    p: 2,
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                    bgcolor: "#fff",
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    navigate("/teacher/scholarship-details", {
                                      state: {
                                        scholarship,
                                        schoolId,
                                        teacherId,
                                      },
                                    })
                                  }
                                >
                                  <CardContent>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 1,
                                      }}
                                    >
                                      <WorkspacesIcon
                                        sx={{ color: "#6200ee", mr: 1 }}
                                      />
                                      <Typography
                                        variant="h6"
                                        sx={{
                                          fontWeight: "600",
                                          color: "#2c3e50",
                                        }}
                                      >
                                        {scholarship.title}
                                      </Typography>
                                    </Box>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666", mb: 1 }}
                                    >
                                      <strong>Type:</strong> {scholarship.type}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666", mb: 1 }}
                                    >
                                      <strong>Organization:</strong>{" "}
                                      {scholarship.hostOrganization}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      sx={{ color: "#666" }}
                                    >
                                      <strong>Deadline:</strong>{" "}
                                      {new Date(
                                        scholarship.deadline
                                      ).toLocaleDateString()}
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </motion.div>
                            </Grid>
                          ))}
                      </Grid>

                      {scholarships.length > 0 && (
                        <Box sx={{ textAlign: "center", mt: 2 }}>
                          <Button
                            variant="outlined"
                            color="primary"
                            onClick={() =>
                              navigate("/teacher/scholarships", {
                                state: { schoolId, teacherId },
                              })
                            }
                            sx={{
                              borderRadius: "8px",
                              textTransform: "none",
                              px: 4,
                            }}
                          >
                            View All Scholarships
                          </Button>
                        </Box>
                      )}
                    </>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {isMobile && (
        <Paper
          sx={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar,
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            py: 1,
            px: 0,
            borderTop: "1px solid #eee",
            borderRadius: 0,
          }}
          elevation={3}
        >
          {[
            {
              icon: <HomeIcon />,
              label: "Home",
              action: () => navigate("/teacher"),
              path: "/teacher",
            },
            {
              icon: <PersonIcon />,
              label: "Students",
              action: () =>
                navigate("/teacher/students", { state: { schoolId } }),
              path: "/teacher/students",
            },
            {
              icon: <VideoLibraryIcon />,
              label: "Videos",
              action: () =>
                navigate("/teacher/videos", { state: { schoolId, teacherId } }),
              path: "/teacher/videos",
            },
            {
              icon: <NoteIcon />,
              label: "Notes",
              action: () =>
                navigate("/teacher/notes", { state: { schoolId, teacherId } }),
              path: "/teacher/notes",
            },
          ].map((item, index) => (
            <Button
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "auto",
                color: pathname === item.path ? "#6200ee" : "#666",
                textTransform: "none",
                p: 1,
              }}
              onClick={item.action}
            >
              <IconButton sx={{ color: "inherit" }}>{item.icon}</IconButton>
              <Typography variant="caption" sx={{ fontSize: "0.65rem" }}>
                {item.label}
              </Typography>
            </Button>
          ))}
        </Paper>
      )}
    </Box>
  );
};

export default TeacherDashboard;